import FaqSection from "@/components/sections/products/shared/faq";
import { MOBILE_PRICING_FAQS } from "./data";

export default function MobilePricingFaq() {
  return (
    <FaqSection
      faqs={MOBILE_PRICING_FAQS}
      description="Everything you need to know about our mobile proxy plans, billing, and setup. Can't find what you're looking for?"
      headingId="faq-heading"
      contactVariant="button"
    />
  );
}
